import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { request } from "../service/api";
import { constructEndpoint } from "../utils/commonHelper";

/**
 * Hook-friendly replacement for the List/Search/Sorting/Pagination helpers in
 * `src/utils/dataTableHelper.js`. Those helpers build the same shape of query
 * params this hook builds, but dispatch a Redux thunk; this hook calls the
 * same `request()` client directly through TanStack Query instead
 */
export interface UseListQueryParams {
  url: string;
  method?: string;
  limit: number | string;
  offset: number;
  search?: string;
  sortType?: string;
  type?: string;
  loadingKey?: string;
  enabled?: boolean;
}

export function useListQuery<T = unknown>({
  url,
  method = "GET",
  limit,
  offset,
  search,
  sortType,
  type,
  loadingKey,
  enabled = true,
}: UseListQueryParams): UseQueryResult<T> {
  const queryParam: Record<string, unknown> = {
    limit,
    offSet: Number.isNaN(offset) ? 0 : offset,
  };
  if (type) queryParam.type = type;
  if (search) queryParam.search = search;
  if (sortType) queryParam.sort = sortType;

  return useQuery({
    queryKey: [url, queryParam],
    queryFn: () => request(constructEndpoint(url, queryParam), { method, loadingKey }) as Promise<T>,
    enabled,
  });
}
